const ORDER_ITEM_PIC_SIZE_KEY = "__ORDER_ITEM_PIC_SIZE_KEY__";
const defaultSize = 40;

export function getOrderItemPicSizeStorage() {
    const sizeCache = localStorage.getItem(ORDER_ITEM_PIC_SIZE_KEY);

    if (!sizeCache) return defaultSize;

    const size = Number(sizeCache);

    if (Number.isNaN(size)) return defaultSize;

    return size;
}

export function saveOrderItemPicSizeStorage(size: number) {
    localStorage.setItem(ORDER_ITEM_PIC_SIZE_KEY, size.toString());
}
